import { screenWidthContext } from "providers/screenWidth";
import { useContext } from "react";

export function useScreenWidth() {
  return useContext(screenWidthContext);
}
